export const environment = {
  production: true,
  apiBaseUrl: 'https://admin.franify.com',
};
